/*!
=========================================================
*　調査詳細
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardHeader, CardBody, CardImg,
  Table, Row, Col,
  FormGroup, Label, 
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import _ from 'underscore';
import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import Common from '../../common/Common';
import TitleWithBadge from '../FormParts/TitleWithBadge';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import InputCheckBox from '../FormParts/InputCheckBox';
import InputNumber from '../FormParts/InputNumber';
import GoogleMapEx from '../ViewParts/GoogleMapEx';
//import CustomTable from '../ViewParts/CustomTable';
import CustomTable from '../ViewParts/OriginalTable';
import CustomTableNoPager from '../ViewParts/OriginalTableNoPager';
import UserSelectPopup from '../ViewParts/UserSelectPopup';
import CustomTd from '../ViewParts/CustomTd';
import Format from '../../common/Format';
import FormatCode from '../../common/FormatCode';
import GoogleDrive from '../../common/GoogleDrive';
import Definition from '../../common/Definition';
import GsuiteAuth from '../../components/Auth/GsuiteAuth'
import {
  cst_request_parking_status,
  cst_route_map_parking_flag,
  cst_transshipment_flag,
  cst_request_box_status,
  REQUEST_BOX_STATUS
} from '../../variables/codes_map';
import WithRole from '../FormParts/ButtonWithRole';
import Validate from "../../common/Validate";
import StaticMap from '../../common/StaticMap'
import InputSelect from "../FormParts/InputSelect";
import DialogBase from "../Base/DialogBase";
import {googleMapKey} from  '../../variables/apikeys';
import MapViews from "../RouteMap/MapViews";
import Badge from '@material-ui/core/Badge';
import {flagMaxCount} from "../../variables/message";


class Detail extends React.Component {
  static default_column = [
    { Header: '駐車場ID', accessor: 'PARKING__parking_natural_id', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '駐車場情報', accessor: '___JOIN_parking_image', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '駐車場住所', accessor: '___JOIN_parking_addr', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '仕入先情報', accessor: '___JOIN_survey_supplier_imformation', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '賃料/手数料', accessor: '___JOIN_parking_cost1', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '空台数', accessor: 'REQUEST_PARKING__request_parking_space_qty', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '敷金/礼金', accessor: '___JOIN_parking_cost2', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '車種別利用可否', accessor: '___JOIN_parking_capacity_flags', headerClassName: "text-center", className: "text-left text-top", nonTargetFilter: true },
    { Header: '直線距離', accessor: 'PARKING__distance', headerClassName: "text-center", className: "text-left text-top", nonTargetFilter: true, sortMethod: (a, b) => {
      const regex = /\D/g
      const meterA = parseInt(a.props.children.replace(regex,''))
      const meterB = parseInt(b.props.children.replace(regex,''))
      return meterA >= meterB ? 1 : -1;
    } },
    { Header: '現場距離', accessor: '___JOIN_survey_distance', headerClassName: "text-center", className: "text-left text-top", sortMethod: (a, b) => {
      const valueA = a.props.dangerouslySetInnerHTML.__html
      const valueB = b.props.dangerouslySetInnerHTML.__html
      const regex = /\D/g
      const numA = parseInt(valueA&&valueA.substring(valueA.indexOf(">"),valueA.length).replace(regex,''))
      const numB = parseInt(valueB&&valueB.substring(valueA.indexOf(">"),valueA.length).replace(regex,''))
      return numA >= numB ? 1 : -1;
    } },
    { Header: '日割/通し可否', accessor: '___JOIN_parking_pay_unit_type', headerClassName: "text-center", className: "text-left text-top" },
    { Header: 'ステータス', accessor: 'REQUEST_PARKING__request_parking_status', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '経路図', accessor: 'REQUEST_PARKING__route_map_parking_flag', headerClassName: "text-center", className: "text-left text-top" },
    // { Header: '所要時間', accessor: 'REQUEST_PARKING__site_distance_minute', headerClassName: "text-center", className: "text-left text-top" },
    { Header: 'ストリートビュー', accessor: 'PARKING__sv_url', headerClassName: "text-center", className: "text-left text-top" },
  ];

  routeDialogColumn = [
    { Header: 'ラベル', accessor: 'index', headerClassName: "text-center", className: "text-center", maxWitdh:50 },
    { Header: '駐車場名', accessor: 'PARKING__parking_name', headerClassName: "text-center", className: "text-left text-top", minWidth:300 },
    { Header: 'ステータス', accessor: 'REQUEST_PARKING__request_parking_status', headerClassName: "text-center", className: "text-left text-top", maxWitdh:150 },
  ]
  // 空台数	調査駐車場空台数	REQUEST_PARKING__request_parking_space_qty
  
  constructor(props) {
    super(props);
    this.state = {
      parking_data: [],
      parking_page_data: [],
      // survey_id: this.props.match.params.survey_id,
      request_data: {},
      value: "",
      copied: false,
      // column: this.default_column,
      tmp_column: [],
      right_side_open: false,
      request_area_open: false,
      exec_action: 0, // exec_actions { value: 0, label: 'チェックした見積で案内図を作成する' }
      modal:false,
      staticFilteredMap:"",
      error:{},
      searchData:{
        values:{
          search_distance: 500,
        },
        errors:{},
        requiredData:{}
      },
      customer:{
        customer_name : '',
        customer_branch_name : '',
        customer_branch_tel : '',
        customer_user_name : '',
        customer_user_tel: ''
      },
      customer2:{
        customer_name : '',
        customer_branch_name : '',
        customer_branch_tel : '',
        customer_user_name : '',
        customer_user_tel: ''
      },
      routeModalData:[],
      routeModalIndex:0,
      renderMap:false,
      auto_scroll:true,
      checkedItems:[],
      paging:{
        "index": 0,
        "limit": 50
      },
      unique_key:"PARKING__parking_natural_id",
      data_count:0,
      all_checked_status:false,
      detail_search:false,
      isLoad: false,
      mapbounds: {
        ne_lng: null,
        ne_lat: null,
        sw_lng: null,
        sw_lat: null,
      },
      cart_total_count: 0,
      map_leady: false,
      reCalcTarget: []
    };

    this.googlemap = React.createRef();

    this.setReactTableColumn = this.setReactTableColumn.bind(this); 
    this.handle_column = this.handle_column.bind(this);
    this.onClickExecButton = this.onClickExecButton.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.toggleModal = this.toggleModal.bind(this)
    this.showFlaggedParkingMap = this.showFlaggedParkingMap.bind(this)
    this.validateCallBack = this.validateCallBack.bind(this)
    this.closeRequest = this.closeRequest.bind(this)
    this.setCenterRouteMap = this.setCenterRouteMap.bind(this)
    this.setRouteModalIndex = this.setRouteModalIndex.bind(this)
    this.updateSiteLocation = this.updateSiteLocation.bind(this)
    this.dialogConfirm = React.createRef();
    this.dialogCartDetail = React.createRef();
  
    this.allStateClear = this.allStateClear.bind(this);

    var url = '/api/request/' + this.props.match.params.ulid;
    let params = {
    };

    Request.get(url, params,
      res => {
        if(res.Data.request_box_status == REQUEST_BOX_STATUS.CHECK ||
           res.Data.request_box_status == REQUEST_BOX_STATUS.CHECK_OK ||
           res.Data.request_box_status == REQUEST_BOX_STATUS.CHECK_NG){
          this.props.alertModal.current.confirmCheck({
            title:'処理完了',
            messageNo:2530,//見積もり作成ずみ
          },()=>this.props.history.push('/construction/list'),false)
          return  
        } else if(res.Data.request_box_status >= REQUEST_BOX_STATUS.COMPLETE ){
            this.props.alertModal.current.confirmCheck({
              title:'処理完了',
              messageNo:2443,//見積もり送信ずみ
            },()=>this.props.history.push('/construction/list'),false)
            return  
        } else if(res.Data.survey_status==3){
          this.props.alertModal.current.confirmCheck({
            title:'処理完了',
            messageNo:2530,//見積もり作成ずみ
          },()=>this.props.history.push('/construction/list'),false)
          return 
        }else if(res.Data.survey_status==9){
          this.props.alertModal.current.confirmCheck({
            title:'処理完了',
            messageNo:2419
          },()=>this.props.history.push('/construction/list'),false)
          return 
        } else if (res.Data.estimate_create_start_date) {
          this.props.alertModal.current.confirmCheck({
            title:'エラー',
            messageNo:2465,
            closeBtn:false
          },()=>this.returnUrlByRequestBoxStatus(res.Data.request_box_status),false)  
          return
        } else {
          this.setState({
            request_data: res.Data,
            renderMap:true
          },()=>{
            console.log(this.state.request_data);
          });
          const customerUserApiEndPoint = '/api/customer/user'
          if (res.Data.customer_user_id && res.Data.customer_user_natural_id) {
            Request.get(customerUserApiEndPoint, {
              customer_user_natural_id:res.Data.customer_user_natural_id
            }, res=>{
              this.setState({
                customer: res.Data[0]
              })
            })
          }
  
          if (res.Data.subcontract_customer_user_natural_id){
            Request.get(customerUserApiEndPoint, {
              customer_user_natural_id:res.Data.subcontract_customer_user_natural_id
            }, res=>{
              this.setState({
                customer2: res.Data[0]
              })
            })
          }
        }
      })
  }

  static dataMap(data) {
    return data.data.map((prop, key) => {
      const distance = Math.round((prop.distance * 1000) * 100) / 100
      const streetViewUrl = prop.sv_url ? prop.sv_url :`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${prop.latitude},${prop.longitude}`
      const p = {...prop,request_type:data.request_type}
      // const isChecked = checkedItems.findIndex(item => (item.ulid === prop.ulid)) > -1;
      return {
        request_parking:prop.request_parking,
        ulid:prop.ulid,
        prop:prop,
        // checked : initCheck ? (prop.request_parking.want_parking_flag === 1 ? true : false) : isChecked,
        ___JOIN_parking_capacity_flags: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_capacity_flags', prop)}} />,
        ___JOIN_parking_cost1: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_cost1', prop)}} />,
        ___JOIN_parking_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_addr', prop)}} />,
        ___JOIN_survey_supplier_imformation: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_survey_supplier_imformation', prop)}} />,
        PARKING__parking_natural_id: <Link to={'/parking/detail/' + prop.ulid} target="_blank">{`${prop.register_type==1 ? "(*)":""}${prop.parking_natural_id}`}</Link>,
        ___JOIN_parking_cost2: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_cost2', prop)}} />,
        ___JOIN_parking_image: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_image', prop)}} />,
        ___JOIN_parking_pay_unit_type: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_pay_unit_type', prop)}} />,
        PARKING__distance: <span>{Format.comma_delimited(parseInt(distance),"m")}</span>,
        ___JOIN_survey_distance: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_survey_distance', p)}} />,
        REQUEST_PARKING__route_map_parking_flag: <span>{Common.getValueFormDictArray(cst_route_map_parking_flag, prop.request_parking.route_map_parking_flag)}</span>,
        REQUEST_PARKING__request_parking_status: <span>{Common.getValueFormDictArray(cst_request_parking_status, prop.request_parking.request_parking_status)}</span>,
        REQUEST_PARKING__request_parking_space_qty: <span>{Format.comma_delimited(prop.request_parking.request_parking_space_qty,'台')}</span>,
        PARKING__sv_url : <a target="_blank" href={streetViewUrl}>{"開く"}</a>,
      }
    });
  }

  pageChangeHandle( customTable ){
    window.scrollTo(0,customTable.currentRef.current.offsetTop);
    return ;
  }

  validateCallBack(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData,
        values:{
          ...newData.values,
        }
      }
    }, ()=>callback())
  }
/*
  async showFlaggedParkingMap(){
    //const checkedData = this.state.data.filter(item=>item.checked)
    const checkedData = this.state.checkedItems;
    if(checkedData.length<1){
      return
    } else {
      Request.setProgress(10)
      const center = { 
        latitude: this.state.request_data.latitude,
        longitude: this.state.request_data.longitude
      }
      Request.setProgress(40)
      const google_routeModalData = await StaticMap.createStaticGoogleMap(
        center, 
        checkedData.map(item=>item.prop).sort((a, b) => a.request_parking.site_distance_meter - b.request_parking.site_distance_meter),
        this.state.original_data
      )
//      console.log('google_routeModalData', google_routeModalData)
      Request.setProgress(90)
      this.setState({
        routeModalData:google_routeModalData,
        routeModalIndex:0
      }, ()=>{
        Request.setProgress(0)
        this.toggleModal()
      })
    }
  }
*/
  showFlaggedParkingMap(){
    const checkedData = this.state.checkedItems;
    const errorData = this.state.checkedItems.filter(item=>item.route_map_parking_flag == 0);

    if(checkedData.length<1) {
      return
    }
//    console.log(errorData);
    if (errorData.length > 0) {
      this.props.alertModal.current.showErrorModal({
        messageNo:[[2418]]
      });
      return
    }
//    console.log(this.state.checkedItems);

    let selectParking = checkedData.map(item=>item.prop).sort((a, b) => a.request_parking.site_distance_meter > b.request_parking.site_distance_meter);
    let distance_meter_filter = parseInt(selectParking[selectParking.length-1].site_distance_meter);


    let viewParking = this.state.original_data.filter (function(data) {
      // 経路図：表示する　ステータス：満車1
      if (data.route_map_parking_flag == 1 && 
        data.request_parking_status == 3 && 
        data.site_distance_meter < distance_meter_filter)
      {
        let result = selectParking.find(parking=>data.parking_natural_id == parking.parking_natural_id);
        if ( result == undefined) {
          return data
        }
      }
    })

//    console.log(selectParking, viewParking);

    this.props.history.push({
      pathname:"/route-map/route_edit", 
      state: {
//        request : [this.state.request_data],
        parking : selectParking,
        full_parking : []
      }
    });
  }
  setRouteModalIndex(index){
    this.setState({
      routeModalIndex:index
    }, this.setCenterRouteMap(index))
  }

  setCenterRouteMap(index){

    setTimeout(()=>{
      const routeMapDiv = document.getElementById('route-map-div')
      if (routeMapDiv){
        if (this.state.routeModalData[index].canvas) {
          routeMapDiv.appendChild(this.state.routeModalData[index].canvas)
        } 
        routeMapDiv.scrollTop = 640 - routeMapDiv.offsetHeight/2
        routeMapDiv.scrollLeft= 640 - routeMapDiv.offsetWidth/2
      }
    },1000)
  }
  
  componentDidMount(){
    StaticMap.googleMapScript()
    this.refreshCartCount();
  }

  componentWillUnmount(){
    window.google={}
  }

  componentDidUpdate(originalProp, originalState){
    // if ((originalState.request_data===undefined)&&(this.state.request_data)){
    //   this.refreshCartCount();
    // }
    document.body.style.overflow = "auto";
  }

  updateSiteLocation(){
    var url = '/api/request/' + this.props.match.params.ulid;
    let params = {};

    Request.get(url, params, res => {
      this.setState({
        request_data: res.Data,
        renderMap:true
      }, () => {});
    })
  }

  async refreshCartCount() {
    var url = '/api/request/parking/cart';
    const params = {
      request_ulid: this.props.match.params.ulid,
      data_count: true
    };

    Request.get(url, params,
      res => {
        this.setState({
          cart_total_count: res.Data
        }, () => {
        });
      })
  }

  setReactTableColumn(e) {
    this.setState({ column: this.state.tmp_column });
  }
  handle_column(e) {
    var column = [];

    for (var i = 0; i < e.target.length; i++) {

      if (e.target[i].selected === true) {
        column.push(this.default_column[i]);
      }

    }
    this.setState({ tmp_column: column });
  }

  parking_info(prop) {
    return (
      <>
        {prop.parking_picture_url_thumbnail ? (
          <CardImg top src={GoogleDrive.file_url(prop.parking_picture_url_thumbnail)} alt="" style={{ "maxWidth": "100px" }} />
        ) : (
            "画像なし"
          )}
        <Link to={'/parking/detail/' + prop.ulid}>{prop.parking_name}</Link>
      </>
    );
  }

  // 実行ボタン押下時処理
  onClickExecButton() {

    const center = {
      latitude: (this.props.requestData ? this.props.requestData.latitude : 0),
      longitude: (this.props.requestData ? this.props.requestData.longitude : 0)
    }
    var url = '/api/request/parking/cart';

    Request.get(url, {
      request_ulid: this.props.match.params.ulid,
      latitude: center.latitude,
      longitude: center.longitude,
    },
    res => {
        const targetItems = res.data.filter(item=>item.request_parking);
        if(targetItems.length <= 0) {
          console.log("error 2510");
          this.props.alertModal.current.showErrorModal({messageNo:2510});
          return;
        }

        const route_map_parking_flag_error = targetItems.filter((item) => (item.request_parking.route_map_parking_flag==0))

        if (targetItems.length>15 || route_map_parking_flag_error.length>0){
          this.props.alertModal.current.showErrorModal({
            messageNo:[
              ...(targetItems.length>15?[2468]:[]),
              ...(route_map_parking_flag_error.length>0?[2418]:[]),
            ]
          });
          return
        }
        const route_map_view = this.state.parking_data.filter((p)=>p.request_parking.route_map_parking_flag == 1 && p.request_parking.request_parking_status >= 2 && p.request_parking.request_parking_status <= 9)
        console.log(route_map_view,route_map_view.length,flagMaxCount)
        if (route_map_view.length>flagMaxCount){
          this.props.alertModal.current.showErrorModal({messageNo:2615});
          return 
        }else{
          this.nextPage(targetItems,res)
        }


    })
  }
  // 2189 アラート対応
  nextPage(targetItems,res){
    targetItems.sort((a, b) => a.request_parking.site_distance_meter - b.request_parking.site_distance_meter)

    const ulids = targetItems.map((item)=>['ulid', item.request_parking.ulid])
    const params = new URLSearchParams(ulids);

    Request.put("/api/request/"+this.props.match.params.ulid+'?' + params.toString(), {
      ...this.state.request_data,
      estimate_create_start_date:Format.dateToString(new Date(), 'YYYY-MM-DDThh:mm:ss')
    }, () => {
      const targetUlids = targetItems.map(item=>(item.request_parking&&item.request_parking.ulid)||item.keyForRequestParking)
      const flaggedParking = res.data.filter((parking)=>{
          return parking.request_parking.route_map_parking_flag == 1 && parking.request_parking.request_parking_status > 1
      }).filter((flagged=>!targetUlids.includes(flagged.request_parking.ulid)))

      console.log(targetUlids,flaggedParking)

      this.props.history.push({
        pathname:"/route-map/route_edit", 
        state: {
          ulid : this.props.match.params.ulid,
//          request : [this.state.request_data],
          parking : targetItems,
          flagged_parking: flaggedParking
        }
      })
    },
    (err)=>{
      const {status, statusText} = err.response
      this.props.alertModal.current.showErrorModal({title:status, message:statusText});
    },
    undefined,true,true)
  }

  // 実行ボタン押下時処理
  _onClickExecButton() {
    /*
        if (this.state.data.filter(item=>item.checked).length<1){
          return
        }
    */


        if (this.state.checkedItems.length==0) return;
    
        switch (this.state.exec_action) {
          case 0:
    //        const checkedItems = this.state.data.filter(item=> item.checked && (item.request_parking))
            const checkedItems = this.state.checkedItems.filter(item=>item.request_parking)
            const route_map_parking_flag_error = checkedItems.filter((item) => (item.request_parking.route_map_parking_flag==0))
            const request_parking_status_error = checkedItems.filter((item) => (item.request_parking.request_parking_status != "1" && item.request_parking.request_parking_status != "2"))

            // 空台数が０の駐車場は見積登録できない
            const noSpaceParkings = checkedItems.filter(item=>item.request_parking.request_parking_space_qty === 0 || item.request_parking.request_parking_space_qty == null)
            if(noSpaceParkings.length > 0){
              this.props.alertModal.current.showErrorModal({messageNo:2502})
              return;
            }
            

            if (checkedItems.length>15 || route_map_parking_flag_error.length>0 || request_parking_status_error.length>0){
              this.props.alertModal.current.showErrorModal({
                messageNo:[
                  ...(checkedItems.length>15?[2468]:[]),
                  ...(route_map_parking_flag_error.length>0?[2418]:[]),
                  ...(request_parking_status_error.length>0?[2455]:[]),
                ]
              });
              return
            }
            
            checkedItems.sort((a, b) => a.request_parking.site_distance_meter - b.request_parking.site_distance_meter)
            const ulids = checkedItems.map((item)=>['ulid', item.request_parking.ulid])
            const params = new URLSearchParams(ulids);
              
            Request.put("/api/request/"+this.props.match.params.ulid+'?' + params.toString(), {
              ...this.state.request_data,
              estimate_create_start_date:Format.dateToString(new Date(), 'YYYY-MM-DDThh:mm:ss')
            }, () => {
              this.props.history.push({pathname: '/survey/estimate/add', search: '?' + params.toString() + `&request_ulid=${this.props.match.params.ulid}` });
              this.setState({checkedItems:[]});
            },(err)=>{
              const {status, statusText} = err.response
              this.props.alertModal.current.showErrorModal({title:status, message:statusText});
            },undefined,true,true)
        }
      }
        
  toggleModal(){
    this.setState({
      modal:!this.state.modal
    })
  }
/*
  toggleModal(){
    this.setState({
      modal:!this.state.modal
    }, this.setCenterRouteMap(0))
  }
*/
  closeRequest(){
    this.props.alertModal.current.confirmCheck({messageNo:2473},()=>{
      const url = "/api/request/"+this.state.request_data.ulid
      const params = {
        ...this.state.request_data,
        survey_status:9
      }
      Request.put(url, params,
        res => {
//          console.log(res.Data);
          this.returnUrlByRequestBoxStatus()
        })
    })
  }

  replyBoxRequest(){
    this.props.alertModal.current.confirmCheck({messageNo:2517},()=>{
      const url = "/api/request/"+this.state.request_data.ulid
      const params = {
        ...this.state.request_data,
        request_box_status:REQUEST_BOX_STATUS.WAITING_APPLY
      }
      Request.patch(url, params,
        res => {
          if(res.Code === 200) {
            this.props.history.push("/survey/not_yet")
          }
        }
      )
    })
  }

  allStateClear(){
    this.setState({
      checkedItems:[],
      all_checked_status:false
    })
  }
  requestAreaSwitch() {
    this.setState({
      request_area_open: !this.state.request_area_open
    })
  }

  pageData(data, index = 0, limit = 50) {
    return data.slice(
      index * limit,
      index * limit + limit)
  }

  returnUrlByRequestBoxStatus(request_box_status) {
    if(request_box_status === undefined){
      request_box_status = this.state.request_data["request_box_status"]
    }
    switch(request_box_status){
      // 未着手
      case REQUEST_BOX_STATUS.NOT_YET:
        return this.props.history.push("/survey/not_yet")
      // 返答待ち
      case REQUEST_BOX_STATUS.WAITING_APPLY:
        return this.props.history.push("/survey/waiting")
      // チェック
      case REQUEST_BOX_STATUS.CHECK:
        return this.props.history.push("/survey/check_waiting")
      // チェック
      case REQUEST_BOX_STATUS.CHECK_NG:
        return this.props.history.push("/survey/check_waiting")
      default:
        return this.props.history.push("/survey/not_yet")
    }
  }

  render() {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons, this.state.request_data)
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.request_data)
//    console.log('state', this.state)
    let data_count = this.state.data_count ? parseInt(this.state.data_count) : 0;
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col md="12" className="Header">
                      <CardHeader>
                        <Row>
                          <Col md="6">
                            <TitleWithBadge label="調査詳細" count={this.state.tmp_cnt} onclick={() => { this.setTmp(); }} />
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody>
                        <Row className={this.state.detail_search ? 'on' : 'off'}>
                          <CardBody>
                            <Col md="10">
                                <Row style={{marginTop:'1em'}}>
                                  <Col md="2">表示ステータス</Col>
                                  <Col md="6">
                                    <InputCheckBox 
                                        name="REQUEST_PARKING__request_parking_status"
                                        options={cst_request_parking_status} 
                                        validateCallback={this.validateCallBack} 
                                        rootData={this.state.searchData}
                                      />
                                  </Col>
                                </Row>

                                <Row style={{marginTop:'1em'}}>
                                  <Col md="2">絞込条件</Col>
                                  <Col md="6">
                                  <InputCheckBox label=""
                                      name="PARKING__transshipment_flag" 
                                      options={cst_transshipment_flag} 
                                      validateCallback={this.validateCallBack} 
                                      rootData={this.state.searchData}
                                    />                            
                                  </Col>
                              </Row>
                            </Col>
                          </CardBody>
                        </Row>
                        <Row>
                          <CardBody>
                            <Row>
                              <Col md="3">
                                <ButtonWithTooltip
                                  onclick={() => {
                                    this.googlemap.current && this.googlemap.current.search(this.state.searchData);
                                  }}
                                  class="btn-search"
                                  id="tmp"
                                  icon="fas fa-search"
                                  link="#"
                                  label="検索"
                                  message="検索を開始します。"
                                  disabled={!this.state.map_leady}
                                />
                              </Col>
                              <Col md="3">
                                  <div id="detailed-search-button">
                                  <ButtonWithTooltip
                                      onclick={() => { this.setState({ detail_search: !this.state.detail_search }); }} 
                                      class="btn-search" 
                                      id="detail" 
                                      icon="fas fa-angle-down" 
                                      label="詳細検索" 
                                      message="詳細検索を表示します。" />
                                  </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Row>
                        <Row>
                          <Col>
                            案件ID: <Link target="_blank" to={"/construction/parking/detail/" + this.state.request_data.ulid} color="facebook">{this.state.request_data.request_natural_id}</Link><br/>
                            依頼期間: <span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_want_date', this.state.request_data)}} /><br/>
                            ワゴン車: {this.state.request_data.car_qty}台 軽トラック: {this.state.request_data.light_truck_qty}台 2tトラック: {this.state.request_data.truck_qty}台 その他: {this.state.request_data.other_car_qty}台<br/>

                          {this.state.request_area_open ? <>
                            その他詳細: {this.state.request_data.other_car_detail}<br/>
                            顧客からの要望: {this.state.request_data.customer_other_request}<br/>
                            現場名: {this.state.request_data.site_name}<br/>
                            都道府県: {FormatCode.decode("prefecture", this.state.request_data.site_prefecture)}<br/>
                            市区町村: {this.state.request_data.site_city}<br/>
                            番地（町名以降）: {this.state.request_data.site_address}<br/>
                            会社名: {this.state.customer.customer_name}<br/>
                            支店名: {this.state.customer.customer_branch_name}<br/>
                            電話番号: {this.state.customer.customer_branch_tel}<br/>
                            担当者: {this.state.customer.customer_user_name}<br/>
                            携帯電話: {this.state.customer.customer_user_tel}<br/>
                            {/* 2026/01/09 #2516 対応 */}
                            現場担当者: {this.state.request_data.site_customer_user_name}<br/>
                            現場担当者電話番号: {this.state.request_data.site_customer_user_tel}<br/>
                            会社名（下請）: {this.state.customer2.customer_name}<br/>
                            支店名（下請）: {this.state.customer2.customer_branch_name}<br/>
                            電話番号（下請）: {this.state.customer2.customer_branch_tel}<br/>
                            担当者（下請）: {this.state.customer2.customer_user_name}<br/>
                            携帯電話（下請）: {this.state.customer2.customer_user_tel}<br/>
                            依頼BOXステータス: {Common.getValueFormDictArray(cst_request_box_status, this.state.request_data['request_box_status'])}<br/>
                            </> : ''}
                            <div style={{ width: '100%', height: '20px', color: 'blue', verticalAlign: 'middle', textAlign: 'center', cursor:'pointer' }} onClick={() => { this.requestAreaSwitch(); }}>
                              {this.state.request_area_open ? '▲' : '▼'}
                            </div>
                          </Col>
                          <Col md="6">
                            <button style={{border: "none", background: "transparent"}} onClick={() => {this.dialogCartDetail.current.show()}}>
                              <Badge style={{cursor: "pointer"}} badgeContent={this.state.cart_total_count} color="secondary">
                                <img style={{ display: 'inline-block' }} src="/cart.svg" width="35" height="35" alt="empty" />
                              </Badge>
                            </button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ButtonWithTooltipWithRole
                              button_id="BTN_C1_02_01570"
                              onclick={this.onClickExecButton}
                              id="tmp"
                              label="見積登録"
                              message="チェックした駐車場で見積登録"
                            />&nbsp;
                            <Button onClick={this.googlemap.current && this.googlemap.current.moveToOrigin}>元の現場位置に戻る</Button>&nbsp;
                            <ButtonWithRole
                              button_id="BTN_C1_02_01600"
                              color="secondary"
                              onClick={() => { this.closeRequest() }}
                            >
                              調査CLOSE
                            </ButtonWithRole>&nbsp;
                            { this.state.request_data['request_box_status'] == REQUEST_BOX_STATUS.NOT_YET ?
                              <Button
                                color="secondary"
                                onClick={() => { this.replyBoxRequest() }}
                              >
                                返答待ちBOXへ
                              </Button>
                              :<></>
                            }
                          </Col>
                        </Row>
                      </CardBody>
                    </Col>
                  </Row>

                  <CardBody>
                    {this.state.renderMap&&<GoogleMapEx
                      {...this.props}
                      requestData = {this.state.request_data}
                      buttons={this.props.buttons}
                      // parentRefreshFunction={(initCheck)=>{this.search(initCheck)}}
                      parentRefreshFunction={()=>{this.refreshCartCount();}}
                      parentUpdateSiteLocation={()=>{this.updateSiteLocation()}}
                      updateParkingList={(data)=>{
                        let rdata = {data:data,request_type:this.state.request_data.request_type}
                        var parking_data = Detail.dataMap(rdata);
                        this.setState({
                          paging:{
                            "index":0,
                            "limit":this.state.paging.limit
                          },
                          parking_data: parking_data,
                          parking_page_data: this.pageData(parking_data, 0, this.state.paging.limit)
                        }, () => {
                          // console.log(this.state.parking_data);
                        });
                      }}
                      ref={this.googlemap}
                      editable={true}
                      editself={true}
                      aerial={true}
                      center={{
                        latitude: (this.state.request_data ? this.state.request_data.latitude : 0),
                        longitude: (this.state.request_data ? this.state.request_data.longitude : 0)
                      }}
                      // zoom={14}
                      center_pin={1}
                      request_ulid={this.props.match.params.ulid}
                      mapReady={() => {
                        this.setState({
                          map_leady: true
                        });
                      }}
                      onErrorWithCode={(code) => {this.props.alertModal.current.showErrorModal({ messageNo: code });}}
                      onErrorWithMessage={(status, statusText) => {
                        this.props.alertModal.current.showErrorModal({title:status, message:statusText});
                      }}
                      cart_total_count={this.state.cart_total_count}
                      isSurvey={true}
                      />}
                  </CardBody>
                  <Row>
                    <Col md="3" className="text-center">
                      <Button style={{margin: '0px 320px'}} onClick={() => {this.returnUrlByRequestBoxStatus()}}>一覧に戻る</Button>
                    </Col>
                  </Row>
                  <CustomTable
                    count={this.state.parking_data.length}
                    page={0}
                    perPage={this.state.paging["limit"]}
                    perPage_options={[5,10,20,25,50,100,200,300,400,500]}
                    pageIndex={this.state.paging["index"]}
                    handlePageUpdate={(pageIndex)=>{
                      this.setState({
                        paging:{
                          "index":pageIndex,
                          "limit":this.state.paging["limit"]
                        },
                        parking_page_data: this.pageData(this.state.parking_data, pageIndex, this.state.paging["limit"])
                      })
                    }}
                    defaultSorted={[{
                      id:'field_distance'
                    }]}
                    sortable={false}
                    mode={1}
                    column={Detail.default_column}
                    data={this.state.parking_page_data}
                    with_all_check={false}
                    unique_key={this.state.unique_key}
                    limitChangeFunc={(limit)=>{
                      this.setState({
                        paging:{
                          "index":0,
                          "limit":limit
                        },
                        parking_page_data: this.pageData(this.state.parking_data, 0, limit)
                      })
                    }}
                    pageChangeFunc={( customTable,pager) =>{
                      this.setState({
                        paging:pager,
                        parking_page_data: this.pageData(this.state.parking_data, pager.index, pager.limit)
                      })
                      if (this.state.auto_scroll == true) {
                          this.pageChangeHandle(customTable); 
                      }
                      }
                    }
                    clickRowCallback={(item) => { this.googlemap.current.selectWithId(item.ulid) }} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <Modal isOpen={this.state.modal} style={{maxWidth: '690px'}}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">経路図</h5>
          </div>
          <ModalBody>
            <Col md="12">
            </Col>
            <div id="route-map-div" style={{overflow:'none', maxWidth:'640px', maxHeight:'640px', height:"640px"}}>
              <MapViews style={{width:"100%", height:"100%"}}/>
            </div>

          </ModalBody>
          <ModalFooter>
            <Button style={{margin: '0 auto'}} color="secondary" onClick={this.toggleModal}>
              閉じる
            </Button>
          </ModalFooter>
        </Modal>
        <div id="googlemap" style={{display:'none'}}>
            <div id="map"></div>
        </div>
        <DialogConfirm 
            ref={this.dialogConfirm} 
            {...this.props}
            reCalcTarget = {this.state.reCalcTarget}
            positive={true}
            refreshFunction={this.updateSiteLocation}
            request_ulid={this.props.match.params.ulid}
            requestData = {this.state.request_data}
        />
        <DialogCartDetail 
            ref={this.dialogCartDetail} 
            {...this.props}
            checkedData = {this.state.checkedData}
            positive={true}
            refreshFunction={() => {
              this.updateSiteLocation();
              this.refreshCartCount();
              this.googlemap.current && this.googlemap.current.search(this.state.searchData);
            }}
            request_ulid={this.props.match.params.ulid}
            requestData = {this.state.request_data}
            searchData = {this.state.searchData}
            reCalcDistance = {(reCalcTarget) => {
              this.setState({
                reCalcTarget: reCalcTarget
              }, () => {
                this.dialogConfirm.current.show()
              });
            }}
        />
      </>
    );
  }
}

export default Detail;

export class DialogConfirm extends DialogBase {
  constructor(props) {
      super(props);

      this.state = {
          ...this.state,
          title:"チェックした駐車場の距離を再計算します。よろしいですか？",
          dialogData : {
              ...this.state.dialogData,
              requiredData:{},
              errors : {}
          }
      }
  }

  handleClickNegative(){
      this.toggleModal();
  }

  calcDistance(latitude, longitude){
    return new Promise(resolve => {
      const url = `/api/calcdistance?project=${this.props.requestData.latitude},${this.props.requestData.longitude}&parking=${latitude},${longitude}&request_type=${this.props.requestData.request_type}`
      // console.log(url);
      Request.get(url, {}, res => {
          // console.log(res.Data);
          let {site_distance_meter,site_distance_minute } = res.Data

          resolve({site_distance_meter, site_distance_minute})
      }
      , () => {
          this.props.alertModal.current.showErrorModal({messageNo:2477});
      }
      , undefined
      , false)
  })

    // return new Promise(resolve => {
    //     const url = `https://maps.googleapis.com/maps/api/directions/json?key=${this.state.googleMapKey}&origin=${this.props.requestData.latitude},${this.props.requestData.longitude}&destination=${latitude},${longitude}&mode=walking`
    //     Request.get(url, {}, res => {

    //         const buf = res.data['routes'][0]['legs'][0]
    //         const site_distance_meter = Math.round((buf['distance']['value'] ) * 100) / 100
            
    //         if (site_distance_meter > 9999)
    //             site_distance_meter = 9999.99;
    //         const site_distance_minute = Math.round((buf['duration']['value'] / 60) * 100) / 100
    //         if (site_distance_minute > 9999)
    //             site_distance_minute = 9999.99;
    //             resolve({site_distance_meter, site_distance_minute})
    //     }
    //     , () => {
    //         this.props.alertModal.current.showErrorModal({messageNo:2477});
    //     }
    //     , undefined
    //     , false)
    // })
  }

  handleClickPositive() {
      const updateParkingResult = this.props.reCalcTarget.map((parking) => {
        const updatePromise = new Promise(async (resolve, reject) => {
          let url = '/api/request/parking/update';
          const { site_distance_meter, site_distance_minute} = await this.calcDistance(parking.latitude, parking.longitude)
          const params = {
              ...parking,
              parking_pictures: [],
              update_timestamp:parking.request_parking.update_timestamp,
              parking_update_timestamp:parking.update_timestamp,
              supplier_update_timestamp:parking.supplier.update_timestamp,
              parking_latitude : parking.latitude,
              parking_longitude : parking.longitude,
              request_ulid : this.props.request_ulid,
              request_parking_status : parking.request_parking.request_parking_status || 0,
              route_map_parking_flag : parking.request_parking.route_map_parking_flag || 0,
              site_distance_meter,
              site_distance_minute,
              parking_ulid : parking.ulid,
              site_location_update_flag : 0,
              project_id : this.props.requestData.project_id
          };
          if (!parking.request_parking.ulid) {
              const {
                  user_branch_id,
                  id
              } = this.props.requestData
              Request.post(url, {
                  ...params,
                  user_branch:user_branch_id,
                  request:id,
              }, res => {
                resolve(res)
              });
          } else {
              url = url + '/' + parking.request_parking_ulid;
              Request.put(url, params, res => {
                  if(res.Data.ulid){
                    resolve(res)
                  }
              });
          }
        });
        return updatePromise;
      })
      Promise.all(updateParkingResult).then((values) => {
        this.props.refreshFunction();
        this.toggleModal();
      });
  }

  bodyContent() {
      return (<></>);
  }
}

export class DialogCartDetail extends DialogBase {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: "見積駐車場候補",
      positive_label: "候補から除外",
      positive: true,
      newtral: true,
      negative: false,
      dialogData: {
        ...this.state.dialogData,
        requiredData: {},
        errors: {}
      }
    }

    this.customTableNoPagerRef = React.createRef();
  }

  show() {
    this.search();
    super.show();
  }

  handleClickNewtral() {
    this.toggleModal();
  }

  handleClickPositive() {
    let checked = this.customTableNoPagerRef.current.getChecked();
    if(checked.length <= 0) {
      return;
    }
    let cnt = checked.length;
    checked.forEach(item => {
      Request.patch('/api/request/parking/cart/'+item.request_parking.ulid, {}, (res) => {
        // console.log(res);
        if (res.Code===200){
        }
      },(err)=>{
      },() => {
        cnt--;
        if(cnt <= 0) {
          this.props.refreshFunction();
          this.toggleModal();
        }
      },true,true);
    });
  }

  async search() {
    // 延長の場合は対象の駐車場のみ選択可能とする
    const extend_estimate_flag = this.props.requestData.request_type === 2 ? true : undefined

    const center = {
      latitude: (this.props.requestData ? this.props.requestData.latitude : 0),
      longitude: (this.props.requestData ? this.props.requestData.longitude : 0)
    }
    var url = '/api/request/parking/cart';
    const params = {
      request_ulid: this.props.match.params.ulid,
      latitude: center.latitude,
      longitude: center.longitude,
    };

    Request.get(url, params,
      res => {
        const data = {request_type:this.props.requestData.request_type,data:res.data}
        this.setState({
          data: Detail.dataMap(data)
        }, () => {
          // console.log(this.state.data);
        });
      })
    //      console.log(this.state.data);  
  }

  bodyContent() {
    let data_count = 0;
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons, this.props.requestData)
    return <>

      <CustomTableNoPager
        ref={this.customTableNoPagerRef}
        count={data_count}
        page={0}
        // pageIndex={this.state.paging["index"]}
        handlePageUpdate={(pageIndex) => {
        }}
        defaultSorted={[{
          id: 'field_distance'
        }]}
        checkedItems={this.state.checkedItems}
        sortable={false}
        mode={1}
        column={Detail.default_column}
        data={this.state.data}
        with_all_check={true}
        all_check={this.state.all_checked_status}
        unique_key={this.state.unique_key}
        // 駐車場選択
        checkedChangeCallback={(data, targetChecked) => {
        }}
        />
      <ButtonWithTooltipWithRole
        button_id="BTN_C1_02_01545"
        onclick={() => {
          // チェックしているものではなく本ダイアログに表示されているものすべてが対象
          // 旧仕様でのチェック状態がカートに入れた状態と同義のため
          const targetData = this.state.data.map(item => item.prop);
          if(targetData.length > 0) {
            this.props.reCalcDistance && this.props.reCalcDistance(targetData);
          }
          // const checkedData = this.state.data.filter(item => item.checked).map(item => item.prop)
          // this.setState({
          //   checkedData: checkedData
          // })
          // if (checkedData.length > 0) {
          //   this.dialogConfirm.current.show()
          // }
        }}
        disabled={this.props.requestData.site_location_update_flag == 0}
        label="距離再計算"
        message="チェックした駐車場の距離再計算"
      />
    </>;
  }
}